import { memo, useCallback, useEffect, useState } from "react"
import Input from ".."
import { useTranslation } from "react-i18next"
import { DateTime } from "luxon"
import { InputError } from "../types"

type DateSimple = {
  value: string
  onChange: (val: string) => void
  format: string
  placeholder?: string
  onError: (val: InputError) => void
  size?: 'l' | 'm' | 's'
  label?: string
}

const DateSimple = memo(({
  value, onChange, format, placeholder, onError, size = 'l', label
}: DateSimple) => {
  const { t } = useTranslation()
  
  const [dateString, setDateString] = useState<string>()
  const [error, setError] = useState<InputError>()

  // Make sure the value is always returned so it's not undefined if the user does not change it
  useEffect(() => {
    onChange(value)
  }, [])

  useEffect(() => {
    const formatDate = DateTime.fromISO(value).toFormat(format)
    setDateString(formatDate)
  }, [value])

  const onBlur = useCallback(() => {
    let isValid = DateTime.fromFormat(dateString, format).isValid
    if (!format) {
      isValid = DateTime.fromISO(dateString).isValid
    }
    
    if (isValid) onChange(DateTime.fromFormat(dateString, format).toISO())
    else {
      setError({
        type: 'error',
        message: t('Invalid date')
      })
    }
  }, [dateString, onChange, onError])

  return (
    <div className="DateSimple">
      <Input
        type="text"
        value={dateString}
        size={size}
        label={label}
        placeholder={placeholder}
        onInput={(val) => setDateString(val)}
        onBlur={() => onBlur()}
        error={error}
      />
    </div>
  )
})

export default DateSimple
